import Vue from 'vue'
import Vuex from 'vuex'
import createPersist from 'vuex-localstorage'

// Modules
import auth from './modules/auth'
import packages from './modules/packages'

// TODO: fix caching problem
// TODO: fix going back in browser problem
// TODO: substitute axios with fetch

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  modules: {
    auth,
    packages
  },
  strict: debug,
  plugins: [
    createPersist({
      namespace: 'cognito-vue-dashboard',
      initialState: {},
      expires: 4 * 60 * 60 * 1e3 // 4 hours
    })
  ]
})

export default store
